/**
 * Eigenbau: Dünne Fortschrittslinie in Rubriken — 3px, kein Balken.
 *
 * Der Entwurf misst „2 von 4 erfüllt" nicht mit dem 14px-Balken, sondern mit
 * einer 3px-Linie, die in der Rubrikenzeile zwischen Bezeichnung und Verweis
 * läuft (`flex-1 min-w-[60px]`). Grund `--linie2`, Füllung `--tinte`.
 */

import { cx } from "@/lib/utils";

export function Fortschrittslinie({
  anteil,
  label,
  className,
}: {
  /** 0 bis 100, wird auf den Bereich beschnitten. */
  anteil: number;
  label: string;
  className?: string;
}) {
  const gekappt = Math.min(Math.max(anteil, 0), 100);
  return (
    <span
      role="progressbar"
      aria-label={label}
      aria-valuenow={Math.round(gekappt)}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cx("block h-[3px] min-w-[60px] flex-1 bg-linie2", className)}
    >
      <span
        className="block h-full bg-tinte"
        style={{ width: `${gekappt}%` }}
      />
    </span>
  );
}
